class SubscriptionFeatureController extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.id = this.getAttribute('data-section-id');
    this.select = this.querySelector(`#subscription-stage--${this.id}`);
    this.stageContentWrappers = this.querySelectorAll('.subscription-feature__stage-content-inner');

    if (!this.select || this.stageContentWrappers.length === 0) return;

    this.select.addEventListener('change', this.onStageChange.bind(this));
  }

  onStageChange(event) {
    const selectedValue = event.target.value;
    this.updateVisibility(selectedValue);
  }

  updateVisibility(activeValue) {
    this.stageContentWrappers.forEach((wrapper) => {
      const stageId = wrapper.getAttribute('data-stage-id');
      const isActive = stageId === activeValue;

      wrapper.setAttribute('aria-hidden', !isActive);
      // wrapper.style.display = isActive ? 'block' : 'none';
    });
  }
}

customElements.define('subscription-feature-controller', SubscriptionFeatureController);